import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { CompanyActionMenu } from "./CompanyActionMenu";
import { getSmsGatewayUrl, WEB_APP_ENDPOINT } from "../../react-query/endPoints";
import { Switch } from "@mui/material";

export const comapnyInfoDefaultValues = () => ({
  subscriptionId: "",
  emailId: "",
  name: "",
  address: {
    street: "",
    houseNumber: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
  },
  active: true,
  paymentConfirmationNo: "",
  rootUser: "",
  firstName: "",
  lastName: "",
  comments: "",
  validUntil: "",
  locationLongitude: "",
  locationLatitude: "",
  paymentCurrency:"",
  paymentGatewayId:"",
  transactionPercent:"",
  taxPercent:"",
  minimun_balance: 50,
  defaultPriceGroup: 20,
  smsGatewayId: "",
  protocol: "ws://",
  charger_configuration_url: `${process.env.REACT_APP_WEBSOCKET_ENDPOINT}`,
});

export const taxBillingDefaultValues = () => ({
  taxBillingConfig: {
    taxRegimeType: "",
    taxLabel: "",
    taxIDFieldLabel: "",
    invoiceNumberSchema: "",
    taxIDValue: "",
  }
});

export const InternationalizationDefaultValues = () => ({
  localeFromattingSetting: {
    localeCode: "",
    timeZone: "",
    dateFormat: "",
    numberFormat: "",
    addressFormat: "",
  }
});

export const thirdPartySettingsDefaultValues = () => ({
  is_active: true,
  public_key: "",
  secret_key: "",
  merchant_id: "",
  webhook_key: "",
  config_json: "",
});

export const whitelabelInfoDefaultValues = () => ({
  whitelabelInfo:{ 
    url:"" ,  
    whitelabel_provider: "", 
    map_marker_active:"" , 
    map_marker_inUse:"" , 
    map_marker_inactive:"", 
    terms_n_condition_url: "", 
    show_all_chargers: !1, 
    webapp_url: `${WEB_APP_ENDPOINT}/charger/` 
  },
});

export const advancedSettingsDefaultValue = () => ({
  advance_settings: {
    enable_license_payment : true,
    enforce_crm_user_only: false,
    restrict_charger_visibility: false,
    allow_other_cpo_chargers: false,
    allow_manual_balance_edit:false,
    erp_company_id: "",
    erp_company_name: ""
  }
});

export const productCatalogDefaultValue = () => ({
  productCatalog: "",
});

export const communicationDefaultValue = () => ({
  communication: {
    feedback_config_type: "email",
    support_config_type: "email",
    feedback_email: "",
    support_email: "",
    feedback_crm_id: "",
    support_crm_id: "",
    feedback_case_category_id: "",
    support_case_category_id: "",
  }
});

export const acceptableCurrencyList = [
  { value: "INR", title: "Indian Rupees" },
  { value: "CAD", title: "Canadian Dollars" },
];

const ACCESS_OPTIONS = [
  { label: "Access Allowed", value: 1 },
  { label: "Access Denied", value: 2 },
];

export const companyListColumns = (isReadOnly) => [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 150,
    renderCell: ({ value, id }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "creationTime",
    headerName: "Creation Time",
    flex: 1,
    type: "date",
    minWidth: 200,
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "createdBy",
    headerName: "Created By",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "Actions",
    width: 70,
    sortable: false,
    renderCell: CompanyActionMenu,
  },
];

export const ProductListColumns = (handleRowEdit) => [
  {
    field: "icon",
    headerName: "Icon",
    width: 70,
    renderCell: (params) => (
      <img
        src={params.value}
        alt="icon"
        style={{ width: 20, height: 20, objectFit: "contain", borderRadius: 4 }}
      />
    ),
    sortable: false,
    editable: false,
  },
  {
    field: "title",
    headerName: "Title",
    width: 200,
    editable: true,
    renderCell: (params) => (
      <Tooltip title=
        {
          params.row.access_type !== 0 
            ? "Double click to edit title" 
            : "This is not editable"}>
          <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    width: 250,
    editable: true,
    renderCell: (params) => (
      <Tooltip title=
        {
          params.row.access_type !== 0 
            ? "Double click to edit description"
            : "This is not editable"
        }
      >
        <span>{params.value}</span>
        </Tooltip>
    ),
  },
  {
    field: "url",
    headerName: "URL",
    width: 200,
    editable: true,
    renderCell: (params) => (
      <Tooltip title={
          params.row.access_type !== 0 
            ? "Double click to edit url" 
            : "This is not editable"
          }
      >
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "access_type",
    headerName: "Access Type",
    width: 180,
    editable: true,
    type: "singleSelect",
    valueOptions: ACCESS_OPTIONS,
    renderCell: (params) => {
      const option = ACCESS_OPTIONS.find((opt) => opt.value === params.value);
      return (
        <Tooltip
          title={
            params.row.access_type !== 0
              ? "Double click to change access type"
              : "This is not editable"
          }
        >
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {option ? option.label : "Access Denied"}
            <span style={{ fontSize: 10, color: "#999" }}>▼</span>
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "category",
    headerName: "Category",
    width: 180,
    editable: false,
  },
  {
    field: "is_visible",
    headerName: "Visible",
    width: 100,
    editable: true,
    renderCell: (params) => {
    const handleChangeProductCatalog = (event) => {
      const newValue = event.target.checked ? 1 : 0;
      const updatedRow = {
        ...params.row,
        is_visible: newValue,
      };

      // Let the data grid call processRowUpdate naturally
      handleRowEdit(updatedRow);
    };

    return (
      <Switch
        checked={Boolean(params.value)}
        onChange={handleChangeProductCatalog}
        disabled={params.row.access_type === 0}
      />
    );
  }}
];

export const payoutScheduleDefaultValues = () => ({
  frequencyType: "WEEKLY",
  dayOfWeek: 5,
  daysOfWeek: [5],
  nthOccurrence: null,
  dayOfMonth: null,
  daysOfMonth: [],
  isActive: true,
  lastRunAt: null,
  lastRunStatus: null,
});

export const COMMONTEXT = {
  REGISTRATION_REQUIRED_MESSAGE: "Company registration is required before saving and updating"
}